var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(!_vm.mobileApp)?_c('fragment',[_c('PreHomeContentV2')],1):_c('fragment',[(_vm.preCongressMode)?_c('MobileAppPreHome'):((!_vm.preCongressMode && !_vm.postCongressMode) || (_vm.postCongressMode && !_vm.ressourcesMovedTo365))?_c('MobileAppHappeningNow'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }